import { Outlet } from 'react-router-dom';
import { ConsoleShell, type ConsoleNavItem } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useAuth } from '@/auth/AuthProvider';
import { MobileConsoleScaffold } from './MobileConsoleScaffold';

// View-only console for now: Dashboard, My courses, Learners. Editing surfaces
// (course editor, test setup, attendance, certificate issuing) are intentionally
// hidden until the per-course instructor model lands — all edits happen via the DB.
const ITEMS: ConsoleNavItem[] = [
  { section: 'Teaching' },
  { to: '/teach', end: true, icon: 'home', label: 'Dashboard' },
  { to: '/teach/courses', icon: 'book', label: 'My courses' },
  { to: '/teach/learners', icon: 'users', label: 'Learners' },
  { to: '/teach/attendance', icon: 'qr', label: 'Attendance' },
  { to: '/teach/tests', icon: 'doc', label: 'Test questions' },
  { to: '/teach/analytics', icon: 'chart', label: 'Analytics' },
  { to: '/teach/cert-preview', icon: 'award', label: 'Certificate' },
];

const MOBILE_TABS = [
  { to: '/teach', end: true, icon: 'home' as const, label: 'Home' },
  { to: '/teach/learners', icon: 'users' as const, label: 'Learners' },
  { to: '/teach/attendance', icon: 'qr' as const, label: 'Check-in' },
  { to: '/teach/tests', icon: 'doc' as const, label: 'Tests' },
  { to: '/teach/analytics', icon: 'chart' as const, label: 'Analytics' },
  // Bridge back to the learner side — instructors are learners too (not a role switch).
  { to: '/learn', icon: 'play' as const, label: 'Learn' },
];

export function InstructorLayout() {
  const isDesktop = useIsDesktop();
  const { user } = useAuth();
  const who = {
    name: user ? `${user.title} ${user.firstEn} ${user.lastEn}` : 'Instructor',
    sub: 'ER Team',
    initials: user?.initials ?? 'NW',
    tone: user?.tone ?? ('clay' as const),
  };

  if (!isDesktop) {
    return (
      <MobileConsoleScaffold tabs={MOBILE_TABS}>
        <Outlet />
      </MobileConsoleScaffold>
    );
  }

  return (
    <ConsoleShell brand="Warm Paper" roleLabel="Instructor" items={ITEMS} who={who}>
      <Outlet />
    </ConsoleShell>
  );
}
